import React from 'react';
import { useI18n } from '../context/I18nContext';
import { APPS_DATA } from '../data/apps';
import { SeoHead } from '../components/common/SeoHead';
import { AppCard } from '../components/app/AppCard';

export const AppsIndexPage: React.FC = () => {
  const { t } = useI18n();

  return (
    <div className="py-12 sm:py-16 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <SeoHead
        title="모바일 앱 전체 둘러보기 | Apps"
        description="Kapitalletter가 개발 및 서비스 중인 모든 모바일 앱 제품 라인업을 확인하세요."
        canonicalPath="/apps"
      />

      {/* Header */}
      <div className="max-w-2xl mb-12">
        <span className="text-xs font-bold text-primary-700 tracking-wider uppercase">
          App Portfolio
        </span>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mt-1">
          {t.nav.allApps}
        </h1>
        <p className="mt-3 text-slate-600 text-base sm:text-lg">
          일상의 생산성과 집중을 돕기 위해 정성스럽게 설계된 Kapitalletter의 모바일 앱 제품군입니다.
        </p>
      </div>

      {/* App List */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {APPS_DATA.map((app) => (
          <AppCard key={app.id} app={app} />
        ))}
      </div>
    </div>
  );
};
